import 'src/assets/sass/global.scss';
import './App.scss';

import React from 'react';
import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { config, routes as routeConstants } from 'src/constants';
import { ErrorBoundary, Loading, Notifications } from 'src/core/components';
import messages from 'src/i18n';
import { MCPPage } from 'src/pages';
import { getLoggedUserData, redirectToLogin } from 'src/utils';

// eslint-disable-next-line no-unused-vars
const AppRedirect = () => {
  redirectToLogin();

  return <Loading isLoading />;
};

const App = () => {
  const routes = [{ path: routeConstants.MCP_PAGE, component: MCPPage }];

  const user = getLoggedUserData();

  return (
    <IntlProvider
      key={user.locale}
      locale={user.locale}
      defaultLocale="en"
      messages={messages[user.locale]}
    >
      <ErrorBoundary>
        <Router basename={config.baseRoute}>
          <Switch>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                exact
                component={!user.isAnonymous ? route.component : AppRedirect}
              />
            ))}
          </Switch>
        </Router>
        <Notifications />
      </ErrorBoundary>
    </IntlProvider>
  );
};

export default App;
